export default __webpack_public_path__ + "static/media/group-3-mobile-img3.da438686.png";